import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'channelsLabel',
  standalone: true,
})
export class ChannelsLabelPipe implements PipeTransform {
  transform(channels: string[]): string {
    return channels.map(ch => this.getChannelLabel(ch)).join(', ');
  }

  private getChannelLabel(channel: string): string {
    switch (channel) {
      case 'email':
        return 'Correo electrónico';
      case 'slack':
        return 'Slack';
      case 'calendar_app':
        return 'Notificación';
      default:
        return channel;
    }
  }
}
